import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { palettePrimaryMain as PRIMARY } from '@/theme/designTokens'

export type PreviewSelKey = `opt:${number}` | 'other' | 'none'

export function renderMcCbPreviewControl(selected: boolean, round: boolean) {
  if (round) {
    return (
      <Box
        sx={{
          width: 18,
          height: 18,
          borderRadius: '50%',
          border: `2px solid ${PRIMARY}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {selected ? <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: PRIMARY }} /> : null}
      </Box>
    )
  }
  return (
    <Box
      sx={{
        width: 18,
        height: 18,
        border: `2px solid ${PRIMARY}`,
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        bgcolor: selected ? PRIMARY : 'transparent',
      }}
    >
      {selected ? (
        <Box component="span" sx={{ color: '#fff', fontSize: '12px', lineHeight: 1 }}>
          ✓
        </Box>
      ) : null}
    </Box>
  )
}

type McCbPreviewRowParams = Readonly<{
  rowKey: PreviewSelKey
  label: string
  testId: string
  selected: boolean
  useRadio: boolean
  useTwoColGrid: boolean
  layoutHorizontal: boolean
  mmErr: string | null
  maxSel: number
  exclusiveKeys: ReadonlySet<PreviewSelKey>
  selectedKeys: ReadonlySet<PreviewSelKey>
  onToggle: (key: PreviewSelKey) => void
}>

export function McCbPreviewOptionRow({
  rowKey,
  label,
  testId,
  selected,
  useRadio,
  useTwoColGrid,
  layoutHorizontal,
  mmErr,
  maxSel,
  exclusiveKeys,
  selectedKeys,
  onToggle,
}: McCbPreviewRowParams) {
  const conflictsWithSelectedPath =
    !useRadio &&
    !selected &&
    exclusiveKeys.has(rowKey) &&
    [...selectedKeys].some((selectedKey) => exclusiveKeys.has(selectedKey))
  const atMax = !useRadio && !selected && selectedKeys.size >= maxSel
  const disabled = Boolean(mmErr) || atMax || conflictsWithSelectedPath
  let rowWidth = '100%'
  if (!useTwoColGrid) {
    rowWidth = layoutHorizontal ? 'auto' : '100%'
  }
  return (
    <Box
      component="button"
      type="button"
      data-testid={testId}
      data-selected={selected ? 'true' : 'false'}
      disabled={disabled}
      onClick={() => onToggle(rowKey)}
      sx={{
        bgcolor: '#fff',
        borderRadius: '10px',
        p: 1.5,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        width: rowWidth,
        minWidth: layoutHorizontal && !useTwoColGrid ? 120 : undefined,
        border: '1px solid transparent',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled && !selected ? 0.5 : 1,
        textAlign: 'left',
        font: 'inherit',
      }}
    >
      {renderMcCbPreviewControl(selected, useRadio)}
      <Typography sx={{ fontSize: '14px', color: '#0f172a' }}>{label}</Typography>
    </Box>
  )
}
